import React, { useState } from 'react';
import baseURL from '../../Components/url';
import NavbarWorker from '../../Components/Worker/NavbarWorker/NavbarWorker';
import moneda from '../../Components/moneda';
import { useData } from '../../Components/DataContext';
import { useCaja } from '../../Components/Worker/CajaContext';
import { usePlan } from '../../Components/PlanContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VERSION from '../../Components/version';
import './WorkerHome.css';
import storage from '../../Components/storage';

export default function WorkerHome() {
    const { productos, categorias, mesas, loading, cargarMesas } = useData();
    const { caja, refrescarCaja } = useCaja();
    const { esTienda } = usePlan();
    const [pedido, setPedido] = useState([]);
    const [mesaSeleccionada, setMesaSeleccionada] = useState('');
    const [nota, setNota] = useState('');
    const [nombreCliente, setNombreCliente] = useState('');
    const [telefonoCliente, setTelefonoCliente] = useState('');
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Todo');
    const [busqueda, setBusqueda] = useState('');
        const [enviando, setEnviando] = useState(false);
    const [panelAbierto, setPanelAbierto] = useState(false);
    const [comandaData, setComandaData] = useState(null);

    const usuario = JSON.parse(storage.getItem('adminUser') || '{}');

    const agregarAlPedido = (producto) => {
        const existe = pedido.find(p => p.idProducto === producto.idProducto);
        if (existe) {
            setPedido(pedido.map(p =>
                p.idProducto === producto.idProducto
                    ? { ...p, cantidad: p.cantidad + 1 }
                    : p
            ));
        } else {
            setPedido([...pedido, { ...producto, cantidad: 1, notaProducto: '' }]);
        }
        toast.success(`${producto.titulo} agregado`, { autoClose: 1000 });
    };

    const cambiarNotaProducto = (idProducto, nota) => {
        setPedido(pedido.map(p =>
            p.idProducto === idProducto ? { ...p, notaProducto: nota } : p
        ));
    };

    const quitarDelPedido = (idProducto) => {
        setPedido(pedido.filter(p => p.idProducto !== idProducto));
    };

    const cambiarCantidad = (idProducto, delta) => {
        setPedido(pedido.map(p => {
            if (p.idProducto === idProducto) {
                const nueva = p.cantidad + delta;
                return nueva > 0 ? { ...p, cantidad: nueva } : p;
            }
            return p;
        }));
    };

    const totalPedido = pedido.reduce((sum, p) => sum + (p.precio * p.cantidad), 0);

    const confirmarPedido = async () => {
        if (pedido.length === 0) {
            toast.error('Agrega productos al pedido');
            return;
        }
        if (!esTienda && !mesaSeleccionada) {
            toast.error('Selecciona una mesa');
            return;
        }
        if (!nombreCliente.trim()) {
            toast.error('Ingresa el nombre del cliente');
            return;
        }

        setEnviando(true);
        const productosJSON = pedido.map(p => ({
            idProducto: p.idProducto,
            titulo: p.titulo,
            cantidad: p.cantidad,
            precio: p.precio,
            nota: p.notaProducto || '',
        }));

        const formData = new FormData();
        formData.append('productos', JSON.stringify(productosJSON));
        formData.append('total', totalPedido);
        if (mesaSeleccionada) formData.append('idMesa', mesaSeleccionada);
        formData.append('idTrabajador', usuario.idUsuario);
        formData.append('nombreTrabajador', usuario.nombre);
        formData.append('nombreCliente', nombreCliente.trim());
        formData.append('telefonoCliente', telefonoCliente.trim());
        formData.append('nota', nota);
        if (caja?.idCaja) formData.append('idCaja', caja.idCaja);

        try {
            const response = await fetch(`${baseURL}/pedidoMesaPost.php`, {
                method: 'POST',
                body: formData,
            });
                        const data = await response.json();
            if (data.mensaje) {
                // Guardar datos de la comanda para mostrar modal de impresión
                const mesaInfo = mesas.find(m => String(m.idMesa) === String(mesaSeleccionada));
                setComandaData({
                    idPedido: data.idPedido,
                    mesa: esTienda ? 'Local' : (mesaInfo?.descripcion === 'Mesa General' ? 'Mesa General' : `Mesa ${mesaInfo?.numero || ''}`),
                    cliente: nombreCliente.trim(),
                    trabajador: usuario.nombre || '',
                    productos: productosJSON,
                    total: totalPedido,
                    nota: nota,
                    fecha: new Date().toLocaleString('es-ES'),
                });
                toast.success(data.mensaje);
                setPedido([]);
                setMesaSeleccionada('');
                setNombreCliente('');
                setTelefonoCliente('');
                setNota('');
                cargarMesas();
                refrescarCaja();
            } else {
                toast.error(data.error || 'Error al crear pedido');
            }
        } catch (err) {
            toast.error('Error de conexión');
        }
        setEnviando(false);
    };

    const imprimirComanda = () => {
        window.print();
    };

    const cerrarComanda = () => {
        setComandaData(null);
    };

    const obtenerImagen = (item) => item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;

    const productosFiltrados = productos
        .filter(p => categoriaSeleccionada === 'Todo' || p.idCategoria === categoriaSeleccionada)
        .filter(p => busqueda === '' || p.titulo.toLowerCase().includes(busqueda.toLowerCase()));

    const categoriasConProductos = categorias.filter(cat =>
        productos.some(p => p.idCategoria === cat.idCategoria)
    );

    return (
        <div className='workerContainer'>
            <NavbarWorker />
            <ToastContainer />
            <div className='workerContent'>
                <div className='workerProducts'>
                    <h2>{esTienda ? 'Vender' : 'Tomar Pedido'}</h2>
                    <div className='workerSearch'>
                        <input
                            type="text"
                            placeholder="Buscar producto..."
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                    </div>
                    <div className='workerCategorias'>
                        <button
                            className={categoriaSeleccionada === 'Todo' ? 'catBtn active' : 'catBtn'}
                            onClick={() => setCategoriaSeleccionada('Todo')}
                        >
                            Todo
                        </button>
                        {categoriasConProductos.map(cat => (
                            <button
                                key={cat.idCategoria}
                                className={categoriaSeleccionada === cat.idCategoria ? 'catBtn active' : 'catBtn'}
                                onClick={() => setCategoriaSeleccionada(cat.idCategoria)}
                            >
                                {cat.categoria}
                            </button>
                        ))}
                    </div>

                    {loading ? (
                        <p>Cargando productos...</p>
                    ) : (
                        <div className='workerProductGrid'>
                            {productosFiltrados.map(producto => (
                                <div
                                    key={producto.idProducto}
                                    className='workerProductCard'
                                    onClick={() => agregarAlPedido(producto)}
                                >
                                    {obtenerImagen(producto) && (
                                        <img src={obtenerImagen(producto)} alt={producto.titulo} />
                                    )}
                                    <div className='workerProductInfo'>
                                        <h4>{producto.titulo}</h4>
                                        <p>{moneda} {String(producto.precio).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <button className='togglePanelBtn' onClick={() => setPanelAbierto(!panelAbierto)}>
                    {panelAbierto ? '✕' : `Pedido (${pedido.length})`}
                </button>
                <div className={`workerOrderPanel ${panelAbierto ? 'panelAbierto' : ''}`}>
                    <h3>Pedido Actual</h3>

                    <div className='orderNota'>
                        <label>Cliente:</label>
                        <input
                            type="text"
                            placeholder="Nombre del cliente..."
                            value={nombreCliente}
                            onChange={(e) => setNombreCliente(e.target.value)}
                        />
                    </div>

                    <div className='orderNota'>
                        <label>Teléfono (opcional):</label>
                        <input
                            type="tel"
                            placeholder="Teléfono del cliente..."
                            value={telefonoCliente}
                            onChange={(e) => setTelefonoCliente(e.target.value)}
                        />
                    </div>

                    {!esTienda && (
                        <div className='mesaSelector'>
                            <label>Mesa:</label>
                            <select
                                value={mesaSeleccionada}
                                onChange={(e) => setMesaSeleccionada(e.target.value)}
                            >
                                <option value="">Seleccionar mesa...</option>
                                {mesas.filter(m => m.estado === 'disponible' || m.descripcion === 'Mesa General').map(mesa => (
                                    <option key={mesa.idMesa} value={mesa.idMesa}>
                                        {mesa.descripcion === 'Mesa General' ? 'Mesa General' : `Mesa ${mesa.numero} (${mesa.capacidad} pers.)`}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className='orderItems'>
                        {pedido.length === 0 ? (
                            <p className='emptyOrder'>Sin productos</p>
                        ) : (
                            pedido.map(item => (
                                <div key={item.idProducto} className='orderItem'>
                                    <div className='orderItemInfo'>
                                        <span className='orderItemName'>{item.titulo}</span>
                                        <span className='orderItemPrice'>
                                            {moneda} {String(item.precio * item.cantidad).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                        </span>
                                    </div>
                                    <div className='orderItemActions'>
                                        <button onClick={() => cambiarCantidad(item.idProducto, -1)}>-</button>
                                        <span>{item.cantidad}</span>
                                        <button onClick={() => cambiarCantidad(item.idProducto, 1)}>+</button>
                                        <button className='removeBtn' onClick={() => quitarDelPedido(item.idProducto)}>×</button>
                                    </div>
                                    <input
                                        className='orderItemNota'
                                        type="text"
                                        placeholder={esTienda ? "Ej: talle, color, observación..." : "Ej: sin tomate, extra queso..."}
                                        value={item.notaProducto || ''}
                                        onChange={(e) => cambiarNotaProducto(item.idProducto, e.target.value)}
                                    />
                                </div>
                            ))
                        )}
                    </div>

                    <div className='orderNota'>
                        <input
                            type="text"
                            placeholder="Nota del pedido..."
                            value={nota}
                            onChange={(e) => setNota(e.target.value)}
                        />
                    </div>

                    <div className='orderTotal'>
                        <strong>Total: {moneda} {String(totalPedido).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>
                    </div>

                    <button
                        className='confirmarBtn'
                        onClick={confirmarPedido}
                        disabled={enviando || pedido.length === 0 || (!esTienda && !mesaSeleccionada)}
                    >
                                                                        {enviando ? 'Enviando...' : 'Confirmar Pedido'}
                    </button>
                </div>
            </div>

            {/* Modal de Comanda para imprimir */}
            {comandaData && (
                <div className='comandaOverlay' onClick={cerrarComanda}>
                    <div className='comandaModal' onClick={(e) => e.stopPropagation()}>
                        <div className='comandaImprimible'>
                            <div className='comandaHeader'>
                                <h2>{esTienda ? 'ORDEN' : 'PEDIDO'} N° {comandaData.idPedido}</h2>
                                <p className='comandaFolio'>{comandaData.mesa}</p>
                                <p className='comandaFecha'>{comandaData.fecha}</p>
                            </div>

                            <div className='comandaInfo'>
                                <div className='comandaInfoRow'>
                                    <span className='comandaLabel'>Cliente</span>
                                    <span className='comandaValor'>{comandaData.cliente}</span>
                                </div>
                                <div className='comandaInfoRow'>
                                    <span className='comandaLabel'>{esTienda ? 'Vendedor' : 'Mesero'}</span>
                                    <span className='comandaValor'>{comandaData.trabajador}</span>
                                </div>
                                <div className='comandaInfoRow'>
                                    <span className='comandaLabel'>Estado</span>
                                    <span className='comandaValor estadoPendiente'>Pendiente</span>
                                </div>
                            </div>

                            <table className='comandaTabla'>
                                <thead>
                                    <tr>
                                        <th>Cant</th>
                                        <th>Producto</th>
                                        <th>Precio</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {comandaData.productos.map((prod, i) => (
                                        <tr key={i}>
                                            <td className='comandaCant'>{prod.cantidad}</td>
                                            <td className='comandaProd'>
                                                {prod.titulo}
                                                {prod.nota && <span className='comandaNotaProd'>({prod.nota})</span>}
                                            </td>
                                            <td className='comandaPrecio'>{moneda} {String(prod.precio * prod.cantidad).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className='comandaTotal'>
                                <span>TOTAL</span>
                                <span>{moneda} {String(comandaData.total).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>
                            </div>

                            {comandaData.nota && (
                                <div className='comandaNotaGlobal'>
                                    <strong>Nota del pedido</strong>
                                    <p>{comandaData.nota}</p>
                                </div>
                            )}

                                                        <div className='comandaFooter'>
                                <p>¡Gracias por tu preferencia!</p>
                                <p className='comandaBuenProvecho'>{esTienda ? '¡Gracias por tu compra!' : '¡Buen provecho! 🎉'}</p>
                                <p className='comandaVersion'>v{VERSION}</p>
                            </div>
                        </div>

                        <div className='comandaBotones no-print'>
                            <button className='btnImprimir' onClick={imprimirComanda}>
                                🖨️ Imprimir
                            </button>
                            <button className='btnCerrarComanda' onClick={cerrarComanda}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
